import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Preconnect to image CDN FIRST for faster resource discovery
const preconnect = document.createElement('link');
preconnect.rel = 'preconnect';
preconnect.href = 'https://cdn.magicpatterns.com';
preconnect.crossOrigin = 'anonymous';
document.head.appendChild(preconnect);
// Preload hero image (LCP element) — BEFORE any other scripts
const link = document.createElement('link');
link.rel = 'preload';
link.as = 'image';
link.type = 'image/jpeg';
link.setAttribute('fetchpriority', 'high');
link.href = 'https://cdn.magicpatterns.com/uploads/eEU2dngs6SQqVMH4fvu1Dx/este.jpg';
document.head.appendChild(link);
// Meta Pixel Code - fires BEFORE React render for instant detection
const pixelScript = document.createElement('script');
pixelScript.textContent = `!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');fbq('init','2164784447627848');fbq('track','PageView');`;
document.head.appendChild(pixelScript);
const noscriptPixel = document.createElement('noscript');
noscriptPixel.innerHTML = '<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=2164784447627848&ev=PageView&noscript=1"/>';
document.body.appendChild(noscriptPixel);
// Render app
render(<App data-id="element-238" />, document.getElementById('root'));